import React, {useEffect} from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {logout} from "../../../redux/actions/loginAction";
import Cookies from "universal-cookie";
const cookies = new Cookies();


function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const cookie = cookies.get("jwt");
    if (!cookie) {
      localStorage.clear();
    }
  }, []);

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/signin" />
      }
    />
  );
}

export default ProtectedRoute;
